import {Component, Input} from '@angular/core';
import {NgForOf, NgIf} from '@angular/common';
import {PolarisCitation} from '../../../../../services/polaris/model';
import {AssetVersionPipe} from '../../../../../pipes/asset-version.pipe';

@Component({
  selector: 'app-copilot-citations-message',
  imports: [
    NgIf,
    NgForOf,
    AssetVersionPipe
  ],
  templateUrl: './copilot-citations-message.component.html',
  styleUrl: './copilot-citations-message.component.scss'
})
export class CopilotCitationsMessageComponent {
  @Input() citations: PolarisCitation[] | undefined;

  getDomain(url: string): string {
    try {
      return new URL(url).hostname.replace(/^www\./, '');
    } catch {
      return url;
    }
  }
}
